import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { StatusCode } from '@hungryroot/rest';
import { getCustomerExperiments } from '@hungryroot/rest/api/v2/customers/[id]/experiments/get';

interface CustomerExperimentValue {
  experiment: number;
  variant: 0 | 2 | 3 | 1 | -2 | -1;
}

interface GetCustomerExperimentsResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: CustomerExperimentValue[];
}

interface Params {
  customerId: number;
  limit?: number;
  offset?: number;
}

type Options = {
  enabled?: boolean;
};

export function useCustomerExperiments(
  key: Array<string | number>,
  params: Params,
  options: Options = {}
): UseQueryResult<GetCustomerExperimentsResponse> {
  return useQuery({
    queryKey: key,
    queryFn: async () => {
      const resp = await getCustomerExperiments(params);
      const { status } = resp;

      if (status !== StatusCode.SuccessOK) {
        throw resp.data as GetCustomerExperimentsResponse;
      }

      return resp.data;
    },
    enabled: options.enabled,
    staleTime: 5 * 60 * 1000,
  });
}
